module.exports = __webpack_public_path__ + "static/media/carousel5.ceb24892.jpeg";